// extracted by mini-css-extract-plugin
module.exports = {"imgAudio":"VideoInfo_imgAudio__2UoKL","img":"VideoInfo_img__1qmAq"};